import React, { ChangeEvent, useState } from 'react'
import { Button, Checkbox, Col, Form, Input, Row } from 'antd'

import MaskedInput from 'react-text-mask'

import './AcessoLoginForm.css'

const { Password } = Input

// ─── Types ────────────────────────────────────────────────────────────────────

interface AcessoLoginFormValues {
  cnpjoucpf: string
  login: string
  senha: string
}

interface AcessoLoginFormProps {
  loading: boolean
  onSubmit: (values: AcessoLoginFormValues) => void
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

const areCredentialsSaved = (): boolean =>
  !!(
    globalThis.localStorage.getItem('earetaguarda_usuario_cnpjoucpf') &&
    globalThis.localStorage.getItem('earetaguarda_usuario_login')
  )

const removeCredentials = (): void => {
  globalThis.localStorage.removeItem('earetaguarda_usuario_cnpjoucpf')
  globalThis.localStorage.removeItem('earetaguarda_usuario_login')
}

const saveCredentials = ({ cnpjoucpf, login }: AcessoLoginFormValues): void => {
  globalThis.localStorage.setItem('earetaguarda_usuario_cnpjoucpf', cnpjoucpf)
  globalThis.localStorage.setItem('earetaguarda_usuario_login', login)
}

const cnpjMask = [
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '.',
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '.',
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '/',
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  /[a-zA-Z0-9]/,
  '-',
  /\d/,
  /\d/,
] as const

const cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/] as const

const getCnpjCpfMask = (input: string): (string | RegExp)[] => {
  const cleaned = input.replace(/[^a-zA-Z0-9]/g, '')
  const isCnpj = cleaned.length > 11 || /[a-zA-Z]/.test(cleaned)
  return isCnpj ? [...cnpjMask] : [...cpfMask]
}

// ─── Component ────────────────────────────────────────────────────────────────

const AcessoLoginForm: React.FC<AcessoLoginFormProps> = ({ loading = false, onSubmit }) => {
  const [areSavingCredentials, setAreSavingCredentials] = useState<boolean>(areCredentialsSaved)

  const [cpfCnpjValue, setCpfCnpjValue] = useState<string>(() =>
    (globalThis.localStorage.getItem('earetaguarda_usuario_cnpjoucpf') || '').toUpperCase(),
  )

  const handleCpfCnpjChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setCpfCnpjValue(event.target.value.toUpperCase())
  }

  const handleSubmit = (values: AcessoLoginFormValues): void => {
    if (areSavingCredentials) {
      saveCredentials(values)
    } else {
      removeCredentials()
    }

    globalThis.localStorage.setItem('usuario_nome', values.login)
    onSubmit(values)
  }

  return (
    <Form
      className="acesso-login-form__container"
      layout="vertical"
      name="acesso-login-form"
      validateMessages={{
        required: 'Campo obrigatório.',
      }}
      onFinish={handleSubmit}
    >
      <Row gutter={16}>
        <Col xs={24}>
          <Form.Item
            initialValue={globalThis.localStorage.getItem('earetaguarda_usuario_cnpjoucpf')?.toUpperCase()}
            label="CNPJ ou CPF"
            name="cnpjoucpf"
            getValueFromEvent={(event: ChangeEvent<HTMLInputElement>) => event.target.value.toUpperCase()}
            rules={[{ required: true }]}
          >
            <MaskedInput
              className="ant-input"
              mask={getCnpjCpfMask}
              value={cpfCnpjValue}
              onChange={handleCpfCnpjChange}
              guide={false}
            />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item
            initialValue={globalThis.localStorage.getItem('earetaguarda_usuario_login')}
            label="Usuário"
            name="login"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item label="Senha" name="senha" rules={[{ required: true }]}>
            <Password />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item>
            <Checkbox
              checked={areSavingCredentials}
              onChange={(event) => {
                setAreSavingCredentials(event.target.checked)
              }}
            >
              Lembrar de mim
            </Checkbox>
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item>
            <Button htmlType="submit" loading={loading} type="primary">
              Entrar
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export default AcessoLoginForm
